import { createSlice } from "@reduxjs/toolkit";
// import { AsyncStorage } from 'AsyncStorage';
// import { AsyncStorageKeys } from "../../utils/constants";

const compareSlice = createSlice({
    name: 'compare',
    initialState: {
        selectedProduct: null,
    },
    reducers: {
        setSelectedProduct: (state, action) => {
            console.log(action.payload)

                state.selectedProduct = action.payload;
                // AsyncStorage.setItem(AsyncStorageKeys.Compare, JSON.stringify(state.selectedProduct)).then(result => {
                //     console.log('ok')
                // }).catch(err => {
                //     console.log(err);
                // });
            },  
        clearCompare: (state) => {
            state.selectedProduct = null;
            // AsyncStorage.removeItem(AsyncStorageKeys.Compare).then(result => {
            //     console.log('ok')
            // }).catch(err => {
            //     console.log(err);
            // })
        }
      
    }
});

export const { setSelectedProduct, clearCompare } = compareSlice.actions;
export default compareSlice.reducer;